import React from "react";
import { Camera, Share2, Sparkles, Globe, Compass, ArrowUpRight } from "lucide-react";
import { SectionLabel, SectionHeading } from "./SectionLabel";

const services = [
  {
    icon: Camera,
    title: "Content Creation",
    desc: "Short-form videos, Reels, product content, event coverage, and promotional visuals — produced with the brand and platform in mind.",
  },
  {
    icon: Share2,
    title: "Social Media Management",
    desc: "Content planning, captions, posting strategy, account direction, and the brand consistency needed to grow with intent.",
  },
  {
    icon: Sparkles,
    title: "Brand Identity",
    desc: "Logo direction, colour themes, visual style, tone of voice, and brand presentation — so the business looks and sounds cohesive.",
  },
  {
    icon: Globe,
    title: "Website & Digital Presence",
    desc: "Improving how businesses look online through cleaner visuals, stronger wording, and a more polished overall presentation.",
  },
  {
    icon: Compass,
    title: "Creative Strategy",
    desc: "Helping brands understand what to post, how to present themselves, and how to capture attention with intent rather than guesswork.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-[rgba(198,162,99,0.12)]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <SectionLabel number="01" label="Services" />
            <SectionHeading className="mt-6">
              What Uberti Creative{" "}
              <span className="italic text-gold-metal">offers</span>.
            </SectionHeading>
          </div>
          <p className="lg:col-span-5 text-[rgb(var(--bone-dim))] leading-relaxed">
            Five focused services — used on their own or combined into a full
            digital presence refresh, depending on what the brand needs most.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <article
                key={s.title}
                data-testid={`service-card-${i}`}
                className="card-hover group relative rounded-2xl border border-[rgba(198,162,99,0.14)] bg-[#0e0c09] p-7 flex flex-col h-full"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center border border-[rgba(198,162,99,0.28)] bg-[rgba(198,162,99,0.04)]">
                    <Icon size={20} className="text-[rgb(var(--gold-soft))]" />
                  </div>
                  <span className="sec-num text-xs opacity-70">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-6 font-serif-display text-[28px] text-[rgb(var(--bone))] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-[rgb(var(--bone-dim))] flex-1">
                  {s.desc}
                </p>
                <a
                  href="#contact"
                  data-testid={`service-cta-${i}`}
                  className="mt-7 inline-flex items-center justify-between gap-2 px-5 py-3 rounded-full text-xs tracking-[0.22em] uppercase btn-ghost-gold"
                >
                  Explore Service
                  <ArrowUpRight size={14} />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
